var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"products"},[_c('ProductListGrid',{key:_vm.category.categoryId,attrs:{"parentCategoryId":_vm.category.categoryId,"position":"category_custom"},on:{"productsCount":_vm.updateCount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }